import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Typography } from "@mui/material";
import AddVehicleManufacturer from "components/Manufacturer/VehicleDetails/AddVehicleManufacturer";
import VehicleManufacturerModel from "components/Manufacturer/Models/VehicleManufacturerModel";
import DialogEditManufacturer from "components/Manufacturer/Models/DialogEditManufacturer";
import AddEnableDecebleVehicle from "components/Manufacturer/VehicleDetails/EnableDesableAddVehicleManufacture";
import { ManufacturerTableApi } from "stores/ManufacturerStore/ManufacturerApi";

class VehicleManufacturerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      manufacturername: "",
      id: null,
      file: null,
      editfile: {
        value: null,
        error: false,
        message: "",
      },
      defaultManufacturer: "",

      AddchargingConfirmDaialog: false,
      AddvehicleStatus: "",
      AddvehicleStatusId: "",
      thumbnail:"",
    };
  }

  componentDidMount() {
    this.props.getAddManufacturerAction();
  }

  handleEditOpen = (id, manufacturername,thumbnail) => {
    this.setState({
      openEdit: true,
      id: `${id}`,
      defaultManufacturer: manufacturername,
      thumbnail:thumbnail
    });
  };

  handleOnChange = (e) => {
    this.setState({ manufacturername: e.target.value });
  };

  handleOnChangeEditFile = (e) => {
    let editfile = {
      value: e,
    };
    if (e.size > 102400) {
      editfile["error"] = true;
      editfile["message"] = "File should be less than 1MB";
    }
    this.setState({ editfile });
  };

  handleClickSubmit = async () => {
    const { id, manufacturername, editfile } = this.state;
    let formData = new FormData();
    formData.append("id", id);
    formData.append("name", manufacturername);
    formData.append("file", editfile.value);

    if (editfile.value) {
      if (editfile.value.size < 102400) {
        if (formData) {
          await ManufacturerTableApi.UpdateAddManufacturer(formData);
          await this.props.getAddManufacturerAction();
          this.setState({ openEdit: false });
        }
      } else {
      }
    } else {
      if (formData) {
        await ManufacturerTableApi.UpdateAddManufacturer(formData);

        this.setState({ openEdit: false });

        this.props.getAddManufacturerAction();
      }
    }
  };

  handleEditClose = () => {
    this.setState({ openEdit: false });
  };

  submitManufacturer = async (id, file) => {
    var res = await ManufacturerTableApi.postAddManufacturer(id);
    if (res.status === 1) {
      this.handleClickOpen();
    }
    this.props.getAddManufacturerAction();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  onChangeText(val) {
    this.setState({ manufacturername: val });
  }

  handleStatusAddVehicle = (id, status) => {
    this.setState({
      AddchargingConfirmDaialog: true,
      AddvehicleStatus: status,
      AddvehicleStatusId: id,
    });
  };

  AddhandleChargingModelClose = () => {
    this.setState({ AddchargingConfirmDaialog: false });
  };

  AddhandleEnableClickCharging = async () => {
    const status = this.state.AddvehicleStatus;
    const id = this.state.AddvehicleStatusId;

    if (status === 1) {
      await ManufacturerTableApi.AddVehicleManufatureEnableDisableApi({
        id,
        status: 0,
      });
      this.setState({ AddvehicleStatus: 0 });
      this.props.getAddManufacturerAction();
    } else {
      await ManufacturerTableApi.AddVehicleManufatureEnableDisableApi({
        id,
        status: 1,
      });
      this.props.getAddManufacturerAction();
    }

    this.setState({ AddchargingConfirmDaialog: false });
  };

  render() {
    const data = this.props?.AddManufacturerTable?.result;
    return (
      <Grid container>
        <Stack mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/manufacturer"
            >
              Manufacturer
            </Link>
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              Add Vehicle Manufacturer
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 2, mt: 1 }}>
            <AddVehicleManufacturer
              data={data}
              onClickModel={this.handleClickOpen}
              onClickEdit={this.handleEditOpen}
              submitManufacturer={(val) => this.submitManufacturer(val)}
              handleStatusAddVehicle={this.handleStatusAddVehicle}
              loading={this.props.isloadingAManufacturerTable}
              thumbnail={this.state.thumbnail}
            />

            <AddEnableDecebleVehicle
              open={this.state.AddchargingConfirmDaialog}
              handleEnable={this.AddhandleEnableClickCharging}
              handleclose={this.AddhandleChargingModelClose}
              AddvehicleStatus={this.state.AddvehicleStatus}
            />

            <VehicleManufacturerModel
              handleClose={this.handleClose}
              open={this.state.open}
            />
            <DialogEditManufacturer
              handleClose={this.handleEditClose}
              open={this.state.openEdit}
              data={this.state.defaultManufacturer}
              editfile={this.state.editfile}
              value={this.state.manufacturername}
              handleOnChangeEditFile={this.handleOnChangeEditFile}
              handleOnChange={this.handleOnChange}
              handleClickSubmit={this.handleClickSubmit}
              thumbnail={this.state.thumbnail}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }
}
export default VehicleManufacturerContainer;
